const cleanTemplate = (template, type) => {
  const clonedTemplate = { ...template, type: { ...type, id: type._id } };

  delete clonedTemplate?.error;

  if (type?.value === 'assessment') {
    delete clonedTemplate?.roles;

    const filteredYearLevels = template?.yearLevels?.filter((year) => {
      return year !== 'all';
    });

    clonedTemplate.yearLevels = filteredYearLevels?.map((id) => {
      return { id: id };
    });
  } else if (type?.value === 'survey') {
    delete clonedTemplate?.yearLevels;

    const filteredRoles = template?.roles?.filter((year) => {
      return year !== 'all';
    });
    clonedTemplate.roles = filteredRoles?.map((id) => {
      return { id: id };
    });
  }

  clonedTemplate?.questions?.forEach((question) => {
    delete question?.error;
    delete question?.isActive;
    delete question?.isPreview;
    delete question?.name;

    if (question.options) {
      question.options.forEach((option) => {
        delete option?.error;
        delete option?.maxOptions;

        if (question.variant?.value === 'numeric') {
          option.value = Number(option?.value);
        }
      });
    }
  });

  return clonedTemplate;
};

export default cleanTemplate;
